import type { IconProps } from '../types'

const WarningAlert = ({ width = '36px', height = '36px' }: IconProps) => (
  <svg role='figure' width={width} height={height} viewBox="0 0 36 36">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        {/* eslint-disable-next-line max-len */}
        <path d="M18,0 C8.064,0 0,8.064 0,18 C0,27.936 8.064,36 18,36 C27.936,36 36,27.936 36,18 C36,8.064 27.936,0 18,0 Z" fill="#FFFFFF" />
        {/* eslint-disable-next-line max-len */}
        <path d="M18,6 C11.376,6 6,11.376 6,18 C6,24.624 11.376,30 18,30 C24.624,30 30,24.624 30,18 C30,11.376 24.624,6 18,6 Z" stroke="#F7C800" />
      </g>
      <g transform="translate(17.000000, 12.000000)" fill="#F7C800" fillRule="nonzero">
        <path d="M0,10.4 L2,10.4 L2,13 L0,13 L0,10.4 Z M0,0 L2,0 L2,7.8 L0,7.8 L0,0 Z" />
      </g>
    </g>
  </svg>
)

export { WarningAlert }
